/* istanbul ignore file */
import noop from 'lodash/noop';
const CANCELLATION_SYMBOL = /*@__PURE__*/ Symbol('cancel');
/**
 * Calls the function when animations allow. This implementation uses
 * `requestAnimationFrame`.
 */
export const interactionWrapper = (fn) => {
    let resolve = noop;
    let reject = noop;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    }).catch((e) => {
        if (e === CANCELLATION_SYMBOL)
            return;
        throw e;
    });
    const handle = requestAnimationFrame(() => {
        resolve(fn());
    });
    return {
        cancel: () => {
            cancelAnimationFrame(handle);
            reject(CANCELLATION_SYMBOL);
        },
        then: promise.then.bind(promise),
    };
};
//# sourceMappingURL=interactionWrapper.js.map